import { useEffect } from 'react';

const GLOW_KEYFRAMES_ID = 'hint-glow-keyframes';

const keyframesCSS = `
@keyframes hint-hand-tap {
  0%, 40%, 58%, 100% {
    transform: rotate(-15deg) scale(1);
    filter: brightness(1) drop-shadow(0 2px 4px rgba(0,0,0,0.6));
  }
  46%, 52% {
    transform: rotate(-15deg) scale(0.88);
    filter: brightness(0.65) drop-shadow(0 2px 4px rgba(0,0,0,0.6));
  }
}
@keyframes hint-button-bg-flash {
  0%, 40%, 60%, 100% { fill: white; fill-opacity: 0.1; }
  48%, 52%            { fill: rgba(250, 204, 21, 0.9); fill-opacity: 0.9; }
}
@keyframes hint-button-icon-flash {
  0%, 40%, 60%, 100% { fill: white; fill-opacity: 0.75; }
  48%, 52%            { fill: rgba(250, 204, 21, 1); fill-opacity: 1; }
}
@keyframes hint-circle-bg-flash {
  0%, 40%, 60%, 100% { fill: white; fill-opacity: 0.1; }
  48%, 52%            { fill: rgba(250, 204, 21, 0.9); fill-opacity: 0.9; }
}
@keyframes hint-circle-glow-flash {
  0%, 40%, 60%, 100% { box-shadow: none; }
  48%, 52%            { box-shadow: 0 0 15px rgba(250, 204, 21, 0.85); }
}
@keyframes hint-hand-enter {
  0% {
    transform: translate(60vw, 60vh);
    opacity: 0;
  }
  100% {
    transform: translate(0, 0);
    opacity: 1;
  }
}
`;

export function useHintGlowStyles() {
  useEffect(() => {
    if (document.getElementById(GLOW_KEYFRAMES_ID)) return;
    const style = document.createElement('style');
    style.id = GLOW_KEYFRAMES_ID;
    style.textContent = keyframesCSS;
    document.head.appendChild(style);
    return () => {
      style.remove();
    };
  }, []);
}

interface HintHandIconProps {
  size?: number;
}

export const HintHandIcon = ({ size = 36 }: HintHandIconProps) => (
  <svg
    width={size}
    height={size * (170 / 135)}
    viewBox="0 0 135 170"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      animation: 'hint-hand-tap 2.5s ease-in-out 3.5s infinite both',
    }}
  >
    <path
      d="M42.5 2.5C50.787 2.5 57.5 9.21304 57.5 17.5V59.1807C59.7737 58.1023 62.3165 57.5 65 57.5C72.7943 57.5 79.3908 62.5787 81.665 69.6113C84.1349 68.2712 86.9693 67.5 90 67.5C97.7943 67.5 104.391 72.5787 106.665 79.6113C109.135 78.2712 111.969 77.5 115 77.5C124.662 77.5 132.5 85.338 132.5 95V125C132.5 148.474 113.474 167.5 90 167.5H89.998L53.0918 167.469V167.468C40.8197 167.467 28.9416 163.17 19.4932 155.296L17.8066 153.891L17.3555 153.51C7.93782 145.449 2.5 133.671 2.5 121.25V109.375C2.5 102.698 5.45267 96.3701 10.584 92.082L10.5869 92.0791L16.5869 87.0791L16.6123 87.0586L16.6387 87.0381C17.1481 86.6359 17.863 86.0383 18.5664 85.5459L22.5 82.792V105C22.5 106.369 23.6307 107.5 25 107.5C26.3693 107.5 27.5 106.369 27.5 105V17.5C27.5 9.21304 34.213 2.5 42.5 2.5Z"
      fill="white"
      stroke="black"
      strokeWidth="5"
    />
  </svg>
);
